'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _send = require('./components/send');

var _send2 = _interopRequireDefault(_send);

var _subscribers = require('./components/subscribers');

var _subscribers2 = _interopRequireDefault(_subscribers);

var _newsletter = require('./components/newsletter.config');

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _newsletter2 = require('./services/newsletter.service');

var _newsletter3 = _interopRequireDefault(_newsletter2);

var _newsletterDataprovider = require('./services/newsletter.dataprovider.service');

var _newsletterDataprovider2 = _interopRequireDefault(_newsletterDataprovider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('newsletters', [_angularUiRouter2.default]).component('newsletter', _send2.default).component('subscriberListing', _subscribers2.default).service('Newsletter', _newsletter3.default).service('NewsletterDataProvider', _newsletterDataprovider2.default).config(_newsletter.NewsletterConfig).name;

// WEBPACK FOOTER //


/** WEBPACK FOOTER **
 ** ./client/app/modules/newsletter/index.js
 **/